import React, { useEffect, useRef, useState } from "react";
import { Range, getTrackBackground } from "react-range";
import { CURRENCY } from "src/lib/constans";

// Define types for the props
interface RangeSliderProps {
  minRange: number;
  maxRange: number;
  step: number;
  currentRanges: [number, number];
  changePriceRanges: (val: number[]) => void;
  showDoneBtn?: boolean;
}

const RangeSlider: React.FC<RangeSliderProps> = ({
  minRange = 0,
  maxRange = 10000,
  step = 1,
  currentRanges = [0, 100],
  changePriceRanges = () => {},
  showDoneBtn = true,
}) => {
  const [inputValues, setInputValues] = useState<number[]>(currentRanges);
  const [showstartinput, setShowstartinput] = useState(false);
  const [showendinput, setShowendinput] = useState(false);
  const startInputRef = useRef<HTMLInputElement>(null);
  const endInputRef = useRef<HTMLInputElement>(null);
  useEffect(() => {
    setInputValues([currentRanges[0], currentRanges[1]]);
  }, [currentRanges]);

  const regex = /^[0-9]+$/;

  useEffect(() => {
    window.addEventListener("click", (e) => {
      if (
        e.target instanceof Node &&
        !startInputRef.current?.contains(e.target) &&
        !endInputRef.current?.contains(e.target)
      ) {
        setShowstartinput(false);
        setShowendinput(false);
      }
    });
    return () => {
      window.removeEventListener("click", (e) => {
        if (
          e.target instanceof Node &&
          !startInputRef.current?.contains(e.target) &&
          !endInputRef.current?.contains(e.target)
        ) {
          setShowstartinput(false);
          setShowendinput(false);
        }
      });
    };
  }, []);

  return (
    <div>
      <div className="range-silder-padding-left">
        <Range
          step={step}
          min={minRange}
          max={10000}
          // max={maxRange}
          values={[
            inputValues[0] > 10000 ? 10000 : inputValues[0],
            inputValues[1] > 10000 ? 10000 : inputValues[1],
          ]} // Use inputValues for slider state
          onChange={(newValues) => {
            setInputValues(newValues);
          }}
          onFinalChange={(newValues) => {
            setInputValues(newValues);
            changePriceRanges(newValues);
          }}
          renderTrack={({ props, children }) => (
            <div
              {...props}
              style={{
                ...props.style,
                height: "4px",
                width: "100%",
                background: getTrackBackground({
                  values: [
                    inputValues[0] > 10000 ? 10000 : inputValues[0],
                    inputValues[1] > 10000 ? 10000 : inputValues[1],
                  ],
                  colors: ["#D1D1D1", "#004540", "#D1D1D1"],
                  min: minRange,
                  max: 10000,
                }),
              }}
            >
              {children}
            </div>
          )}
          renderThumb={({ index, props }) => (
            <div
              {...props}
              style={{
                ...props.style,
                height: "15px",
                width: "15px",
                borderRadius: "50%",
                background: "#004540",
                cursor: "pointer",
              }}
            />
          )}
        />
      </div>
      <div className="value-inputs-categories flex items-center justify-center">
        <div
          onClick={(e) => {
            e.stopPropagation();
            setShowstartinput(true);
            // Use setTimeout to ensure focus happens after state update
            setTimeout(() => {
              startInputRef.current?.focus();
            }, 0);
          }}
          className="font-Lexend-Medium cursor-text w-[49%] max-w-[120px] px-2 outline-none flex items-center gap-1 value-inputs-categories-price font-size-15px range-start-price-text-color"
        >
          <input
            type="text"
            ref={startInputRef}
            style={{ display: showstartinput ? "block" : "none" }}
            className="w-full text-center outline-none"
            value={`${inputValues[0]}`}
            onChange={(e) => {
              let changedValue = parseInt(e?.target?.value?.trim() || "0");
              let lastValue = inputValues[0];
              if (!regex.test(changedValue.toString())) {
                e.target.value = `${lastValue}`;
                return;
              }
              if (changedValue > maxRange) {
                e.target.value = `${maxRange}`;
                return;
              }
              setInputValues([changedValue, inputValues[1]]);
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                (e.target as HTMLInputElement).blur();
              }
            }}
            onBlur={(e) => {
              setShowstartinput(false);
              let changedValue = inputValues[0];
              if (changedValue < minRange || changedValue >= inputValues[1]) {
                setInputValues([currentRanges[0], inputValues[1]]);
                changePriceRanges([currentRanges[0], inputValues[1]]);
              } else {
                changePriceRanges([changedValue, inputValues[1]]);
              }
            }}
          />
          <span
            style={{ display: showstartinput ? "none" : "block" }}
            className="w-full block text-center"
          >{`${CURRENCY} ${
            inputValues[0] > 10000 ? `10000+` : inputValues[0]
          }`}</span>
        </div>
        <div className="font-Poppins-Medium theme-color-green font-size-13px">
          —
        </div>
        <div
          className="font-Lexend-Medium cursor-text w-[49%] max-w-[120px] flex items-center outline-none gap-1 value-inputs-categories-price font-size-15px range-end-price-text-color"
          onClick={(e) => {
            e.stopPropagation();
            setShowendinput(true);
            // Use setTimeout to ensure focus happens after state update
            setTimeout(() => {
              endInputRef.current?.focus();
            }, 0);
          }}
        >
          <input
            type="text"
            ref={endInputRef}
            style={{ display: showendinput ? "block" : "none" }}
            className="w-full text-center outline-none"
            value={`${inputValues[1]}`}
            onChange={(e) => {
              let changedValue = parseInt(e?.target?.value?.trim() || "0");
              let lastValue = inputValues[1];
              if (!regex.test(changedValue.toString())) {
                e.target.value = `${lastValue}`;
                return;
              }
              if (changedValue > maxRange) {
                e.target.value = `${maxRange}`;
                return;
              }
              setInputValues([inputValues[0], changedValue]);
            }}
            onBlur={(e) => {
              setShowendinput(false);
              let changedValue = inputValues[1];
              if (changedValue < inputValues[0]) {
                setInputValues([inputValues[0], currentRanges[1]]);
                changePriceRanges([inputValues[0], currentRanges[1]]);
              } else {
                changePriceRanges([inputValues[0], changedValue]);
              }
            }}
            onKeyDown={(e) => {
              // e.preventDefault();
              if (e.key === "Enter") {
                (e.target as HTMLInputElement).blur();
              }
            }}
          />
          <span
            style={{ display: showendinput ? "none" : "block" }}
            className="w-full block text-center"
          >{`${CURRENCY} ${
            inputValues[1] > 10000 ? `10000+` : inputValues[1]
          }`}</span>
        </div>
      </div>
      {showDoneBtn && (
        <button
          onClick={() => changePriceRanges(inputValues)}
          className="done-button font-Poppins-Medium text-white font-size-16px"
        >
          Done
        </button>
      )}
    </div>
  );
};

export default RangeSlider;
